/**
@format
@flow
*/
import * as React from 'react';
import ButtonIcon from './ButtonIcon';
import type { Props as ButtonIconProps } from './ButtonIcon';
import ButtonPrimary from './ButtonPrimary';
import type { Props as ButtonPrimaryProps } from './ButtonPrimary';
import ButtonDestructive from './ButtonDestructive';
import type { Props as ButtonDestructiveProps } from './ButtonDestructive';
import ButtonSquircle from './ButtonSquircle';
import type { Props as ButtonSquircleProps } from './ButtonSquircle';
import ButtonPill from './ButtonPill';
import type { Props as ButtonPillProps } from './ButtonPill';

type ButtonIconType = {|variant?: 'icon', ...ButtonIconProps|};
type ButtonPrimaryType = {|variant?: 'primary', ...ButtonPrimaryProps|};
type ButtonDestructiveType = {|variant?: 'destructive', ...ButtonDestructiveProps|};
type ButtonSquircleType = {|variant?: 'squircle', ...ButtonSquircleProps|};
type ButtonPillType = {|variant?: 'pill', ...ButtonPillProps|};

type ButtonType = ButtonIconType |
                  ButtonPrimaryType |
                  ButtonDestructiveType |
                  ButtonSquircleType |
                  ButtonPillType;
/**
 * Button orchestrator
 */
const Button: React$ComponentType<ButtonType> = (props: Object): React$Node => {
  const {
    variant,
    ...rest
  } = props;

  switch (variant) {
  case 'icon':
    return <ButtonIcon {...rest} />;
  case 'destructive':
    return <ButtonDestructive {...rest} />;
  case 'squircle':
    return <ButtonSquircle {...rest} />;
  case 'pill':
    return <ButtonPill {...rest} />;
  case 'primary':
  default:
    return <ButtonPrimary {...rest} />;
  }
};

export default Button;
